export default class HeroPlayer {

  static TYPE = {
    YOUTUBE: "youtube",
    VIMEO: "vimeo",
  }

  static SELECTOR_SUFFIX = {
    PLAYER: "hero-iframe",
    CONTAINER: "hero-container",
    BADGE: "hero-badge",
    COVER: "hero-cover",
    IFRAME_CONTAINER: "hero-iframe-container",
  }

  constructor() {
    if (this.constructor == HeroPlayer) {
      throw new Error("Abstract classes can't be instantiated.");
    }

    this.videoHeroPollerInterval = null;

    this.badgeLoadClasses = [
      '$motion/transition:curve:ease-out',
      '$motion/transition:delay:1000ms',
      '$motion/transition:duration:150ms',
    ];
    this.badgeHideClasses = [
      '$motion/transition:curve:ease-in',
      '$motion/transition:delay:0ms',
      '$motion/transition:duration:100ms',
      'layout/invisible',
    ];
    this.badgeShowClasses = [
      '$motion/transition:curve:ease-out',
      '$motion/transition:delay:600ms',
      '$motion/transition:duration:200ms',
    ];
    this.iframeHideClasses = [
      '$motion/transition:curve:ease-out',
      '$motion/transition:delay:0ms',
      '$motion/transition:duration:300ms',
      'layout/invisible',
    ];

    this.iframeShowClasses = [
      '$motion/transition:curve:ease-in',
      '$motion/transition:delay:300ms',
      '$motion/transition:duration:600ms',
    ];
    this.coverHideClasses = [
      '$motion/transition:curve:ease-out',
      '$motion/transition:delay:300ms',
      'layout/invisible',
    ];

    this.coverShowClasses = [
      '$motion/transition:curve:ease-in',
      '$motion/transition:delay:100ms',
      'color/backdrop:blur',
    ];

    this.initInteractions();
  }

  initInteractions() {
    window.addEventListener("DOMContentLoaded", e => {
      if (this.getHeroContainer()) {
        this.getHeroContainer().addEventListener('click', () => {
          this.toggleVideo();
        });
        this.getHeroContainer().addEventListener('keypress', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.toggleVideo();
          }
        });
        this.getHeroBadge().classList.remove('layout/invisible');
      }
    });
  }

  play() {
    throw new Error("Method 'play()' must be implemented.");
  }

  pause() {
    throw new Error("Method 'pause()' must be implemented.");
  }

  pauseVideoListener() {
    throw new Error("Method 'pauseVideoListener()' must be implemented.");
  }

  toggleVideo() {
    if (this.getHeroIframeContainer().classList.contains('layout/invisible')) {
      window.MoMA.scrollTo(this.getHeroContainer());
      this.play();
      this.videoHeroPollerInterval = setInterval(this.videoHeroPoller, 500);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'event': 'gtm.mdeHeroVideoPlayback',
      });
    } else {
      this.getHeroIframeContainer().addEventListener('transitionend', this.pauseVideoListener, false);
    }

    this.toggleIframe();
  }

  toggleIframe() {
    if (this.getHeroIframeContainer().classList.contains('layout/invisible')) {
      this.getHeroBadge().classList.add(...this.badgeHideClasses);
      this.getHeroBadge().classList.remove(...this.badgeLoadClasses);
      this.getHeroBadge().classList.remove(...this.badgeShowClasses);
      this.getHeroContainer().classList.remove('link/cursor');
      this.getHeroCover().classList.add(...this.coverShowClasses);
      this.getHeroCover().classList.remove(...this.coverHideClasses);
      this.getHeroIframeContainer().classList.add(...this.iframeShowClasses);
      this.getHeroIframeContainer().classList.remove(...this.iframeHideClasses);
    } else {
      this.getHeroBadge().classList.add(...this.badgeShowClasses);
      this.getHeroBadge().classList.remove(...this.badgeHideClasses);
      this.getHeroContainer().classList.add('link/cursor');
      this.getHeroCover().classList.add(...this.coverHideClasses);
      this.getHeroCover().classList.remove(...this.coverShowClasses);
      this.getHeroIframeContainer().classList.add(...this.iframeHideClasses);
      this.getHeroIframeContainer().classList.remove(...this.iframeShowClasses);
    }
  }

  getVideoHeroPoller() {
    if (this.isVideoEnd())
      this.toggleVideo();
  };

  isVideoEnd() {
    this.player.getDuration() > 0 && (this.player.getCurrentTime() > this.player.getDuration() - 2);
  }

  getIframeMount() {
    throw new Error("Method 'getIframeMount()' must be implemented.");
  }

  getHeroContainer() {
    throw new Error("Method 'getHeroContainer()' must be implemented.");
  }

  getHeroBadge() {
    throw new Error("Method 'getHeroBadge()' must be implemented.");
  }

  getHeroCover() {
    throw new Error("Method 'getHeroCover()' must be implemented.");
  }

  getHeroIframeContainer() {
    throw new Error("Method 'getHeroIframeContainer()' must be implemented.");
  }
}
